import './App.css';
import WordScramble from "./components/wordscrumble/Wordscrumble";

function App() {
  return (
    <div className="App">
       <main>
        <WordScramble />
      </main>
    </div>
  );
}

export default App;
